import { createStore, Store } from 'vuex';

import { useStore as baseUseStore } from 'vuex';

import tool  from '@/utils/tool';
import RootModuleTypes, {AllStateTypes} from '@/store/interface';
import { InjectionKey } from 'vue';
import loginModule from '@/store/modules/login';
import accountListModule from '@/store/modules/middleGround/member/accountList';
import prototypeRoomListModule from '@/store/modules/middleGround/member/prototypeRoomList';
import subscribeModule from '@/store/modules/middleGround/my/subscribe';
import passwordModule from '@/store/modules/middleGround/my/password';
import projectModule from '@/store/modules/middleGround/investment/project';
import investModule from '@/store/modules/middleGround/investment/invest';
import recruitModule from '@/store/modules/middleGround/recruit';
import communityModule from '@/store/modules/middleGround/community/community';
import newsModule from '@/store/modules/middleGround/my/news';
import noticesModule from '@/store/modules/middleGround/my/notices';
import applyModule from '@/store/modules/middleGround/my/apply';
import informationModule from '@/store/modules/middleGround/my/information';
import companyModule from '@/store/modules/middleGround/my/company';
import companyRoleModule from '@/store/modules/middleGround/member/companyRole';
import subCompanyListModule from '@/store/modules/middleGround/member/subCompanyList';
import albumModule from '@/store/modules/middleGround/member/album';
import operateLogModule from '@/store/modules/middleGround/member/operateLog';
import businessModule from '@/store/modules/middleGround/member/business';
import membershipFeesModule from '@/store/modules/middleGround/member/membershipFees';

import frontNewsModule from '@/store/modules/frontDesk/news';
import frontBbsModule from '@/store/modules/frontDesk/bbs';
import frontBrandModule from '@/store/modules/frontDesk/brand';
import frontIndexModule from '@/store/modules/frontDesk/index';
import frontInvestModule from '@/store/modules/frontDesk/invest';
import frontTrainingModule from '@/store/modules/frontDesk/training';
import frontIndustryModule from '@/store/modules/frontDesk/industry';
import frontLeagueModule from '@/store/modules/frontDesk/league';
import frontRegisterModule from '@/store/modules/frontDesk/register';
import frontCompanyModule from '@/store/modules/frontDesk/company';


export default createStore<RootModuleTypes>({
  state: {
    unLoginList:['Index','Home'],        //不需要登录的页面
  },
  mutations: {
    loginMember(state, member) {
      state.loginMember = member;
  },
  },
  actions: {
      getMyInfo(context) {
      return new Promise((resolve, reject) => {
        tool.post("/frontend/index/anon/getMyInfo", {}).then(data => {
          if (data.status === 2000) {
            context.commit('loginMember', data.result);
            resolve(data);
          }
          else {
            reject(data);
          }
        });
      });
    },
    getMyInfoAndCheckLogin(context) {
      return new Promise((resolve, reject) => {
        tool.post("/frontend/index/getMyInfoAndCheckLogin", {}).then(data => {
          if (data.status === 2000) {
            context.commit('loginMember', data.result);
            resolve(data);
          }
          else {
            reject(data);
          }
        });
      });
    },
    memberLogout(context) {
        return new Promise((resolve, reject) => {
            tool.post("/login/logout", {}).then(data => {
                if (data.status === 2000) {
                    context.commit('loginMember', {});
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
    },
  },
  modules: {
    loginModule,
    accountListModule,
    prototypeRoomListModule,
    subscribeModule,
    passwordModule,
    projectModule,
    investModule,
    recruitModule,
    communityModule,
    newsModule,
    noticesModule,
    applyModule,
    informationModule,
    companyModule,
    companyRoleModule,
    subCompanyListModule,
    albumModule,
    operateLogModule,
    businessModule,
    membershipFeesModule,
    frontNewsModule,
    frontBbsModule,
    frontBrandModule,
    frontIndexModule,
    frontInvestModule,
    frontTrainingModule,
    frontIndustryModule,
    frontLeagueModule,
    frontRegisterModule,
    frontCompanyModule
  },
});

export const key: InjectionKey<Store<RootModuleTypes>> = Symbol('vue-store')

export function useStore<T = AllStateTypes>(){
  return baseUseStore<T>(key);
}
